import React from 'react';
import { CheckCircle2, Star } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-16 md:py-24 pb-28 md:pb-24 bg-ocean-teal text-white relative overflow-hidden" data-id="element-38">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-39">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-white blur-3xl" data-id="element-40"></div>
        <div className="absolute bottom-0 right-0 w-full h-1/2 bg-gradient-to-t from-ocean-teal-dark to-transparent" data-id="element-41"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-42">
        <h2 className="text-3xl md:text-5xl font-bold mb-5 md:mb-6 text-white" data-id="element-43">
          Tu negocio no necesita más improvisación. Necesita estructura.
        </h2>

        <p className="text-lg md:text-xl text-ocean-teal-light mb-8 md:mb-10 max-w-2xl mx-auto" data-id="element-44">
          Empezá hoy con un sistema pensado para ayudarte a ordenar tu atención,
          tus precios, tu operación y tu crecimiento.
        </p>

        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-6 md:p-10 mb-8 md:mb-10 border border-white/20 w-full md:w-auto md:inline-block text-left" data-id="element-45">
          <ul className="space-y-3 mb-8" data-id="element-46">
            {['Sistema 360 Lash', '6 tomos', '6 bonos', 'Acelerador Profesional', 'Acceso inmediato', 'Garantía de 7 días'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-47">
                <CheckCircle2 className="w-5 h-5 text-ocean-gold-light" data-id="element-48" />
                <span className="text-lg font-medium" data-id="element-49">{item}</span>
              </li>)}
          </ul>

          <div className="text-center mb-6" data-id="element-50">
            <div className="text-ocean-teal-light line-through text-sm mb-1" data-id="element-51">
              De $47.990
            </div>
            <div className="text-3xl font-bold text-ocean-gold-light" data-id="element-52">
              a solo $27.990 hoy
            </div>
          </div>

          <a href="https://www.tera-ventasonline.shop/cart/45111856431219:1" target="_blank" rel="noopener noreferrer" className="w-full py-4 px-8 bg-ocean-gold hover:bg-ocean-gold-dark text-white rounded-xl font-bold text-lg transition-colors shadow-lg flex items-center justify-center gap-2" data-id="element-53">
            <span aria-hidden="true" data-id="element-54">🚀</span>
            QUIERO EL SISTEMA 360 LASH COMPLETO
          </a>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-ocean-teal-light" data-id="element-55">
          <span data-id="element-56">Acceso inmediato — Entrega digital</span>
          <span className="hidden sm:inline" data-id="element-57">•</span>
          <div className="flex items-center gap-1" data-id="element-58">
            <div className="flex text-ocean-gold-light" data-id="element-59">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 fill-current" data-id="element-60" />)}
            </div>
            <span data-id="element-61">4.9/5 — Reseñas verificadas</span>
          </div>
          <span className="hidden sm:inline" data-id="element-62">•</span>
          <span data-id="element-63">Garantía de 7 días — Riesgo cero</span>
        </div>
      </div>
    </section>;
}